import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { TreeGroupComponent } from './tree-group/tree-group.component';
import { TreeNestedNodeComponent } from './tree-nested-node/tree-nested-node.component';
import { TreeComponent } from './tree/tree.component';
import { TreeSearchComponent } from './tree-search/tree-search.component';
import { DirectivesModule } from '../../directives/directives.module';
import { IconModule } from '../icon/icon.module';
import { NodeActionsModule } from '../node-actions/node-actions.module';
import { NgxGoogleAnalyticsModule } from 'ngx-google-analytics';

@NgModule({
  imports: [
    CommonModule,
    IconModule,
    MaterialModule,
    NodeActionsModule,
    DirectivesModule,
    NgxGoogleAnalyticsModule
  ],
  declarations: [
    TreeComponent,
    TreeGroupComponent,
    TreeNestedNodeComponent,
    TreeSearchComponent
  ],
  exports: [
    TreeComponent,
    TreeGroupComponent,
    TreeNestedNodeComponent,
    TreeSearchComponent
  ]
})
export class TreeModule { }
